import React, { useEffect } from "react";
import { useTranslation } from "next-i18next";

import { PaymentPeriod } from "@nf/common";
import { ROUTES } from "@nf/constants";

import { IPaymentV2ScreenRouteProps } from "../../PaymentScreen";
import { PaymentErrors } from "../PaymentError";
import { DotsLoader } from "../../../../components/DotsLoader";
import { StepsProgressBar } from "../StepsProgressBar";
import Button from "components/Button";
import { SimpleOfferCard } from "components";
import { useCreatePaymentOrder } from "../../hooks/useCreatePaymentOrder";
import { useBuildLocalizedAbsolutedUrl, useOffers, useRouter } from "hooks";

import styles from "./PaymentDetails.module.scss";

export const PaymentDetails = () => {
  const { t } = useTranslation("translations");
  const router = useRouter();
  const query = router.query as IPaymentV2ScreenRouteProps;
  const offerId = query.offerId;
  const offerHandle = query.offerHandle;

  const buildLocalizedAbsoluteUrl = useBuildLocalizedAbsolutedUrl();

  const { offers } = useOffers();

  const selectedOffer = offers?.find((offer) => `${offer.Id}` == offerId);

  const {
    data: paymentOrder,
    isLoading: isPaymentOrderLoading,
    mutate: createPaymentOrder,
  } = useCreatePaymentOrder({
    onError: (error) => {
      if (error.Message === PaymentErrors.ACTIVE_SUBSCRIPTION_BLOCKING) {
        return router.replace(ROUTES.SETTINGS_SUBSCRIPTION);
      }

      router.replace({
        pathname: ROUTES.PAYMENT_SUBSCRIPTION,
        query: { offerId, offerHandle, error: error.Message },
      });
    },
  });

  useEffect(() => {
    if (offerId && offerHandle && !paymentOrder) {
      createPaymentOrder({
        OfferId: offerId,
        OfferHandle: offerHandle,
        AcceptUrl: buildLocalizedAbsoluteUrl(
          ROUTES.ASSIGNING_SUBSCRIPTION_SCREEN
        ),
        CancelUrl: `${buildLocalizedAbsoluteUrl(
          ROUTES.PAYMENT_DETAILS
        )}?offerId=${offerId}&offerHandle=${offerHandle}`,
      });
    }
  }, [offerId, offerHandle, paymentOrder]);

  if (!paymentOrder || isPaymentOrderLoading) {
    return (
      <div className={styles.container}>
        <DotsLoader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <StepsProgressBar activeStep={4} />

      <h2 className={styles.title}>{t("web_payment_header")}</h2>

      <div className={styles.offers}>
        {selectedOffer && <SimpleOfferCard active offer={selectedOffer} />}
      </div>

      <p className={styles.description}>
        {selectedOffer?.Period === PaymentPeriod.Month
          ? t("web_payment_description")
          : t("web_payment_description_annual")}
      </p>

      {paymentOrder.CheckoutUrl && (
        <Button
          href={paymentOrder.CheckoutUrl}
          variant="primary"
          className={styles.payment}
        >
          {t("web_payment_select_subscription_button")}
        </Button>
      )}
    </div>
  );
};

export default PaymentDetails;
